import yup from 'helpers/validation';
import moment from 'moment';
import { FormValues } from '../types';
import { FACILITY_MANAGER } from 'helpers/users';

export const validationSchema = (regTypeId: number) => yup.lazy(values => yup.object().shape({
    fname: yup
        .string()
        .required('This field is required.')
        .matches(
            /^[a-zA-Z0-9\s\'-]+$/,
            'Please enter a valid name.',
        ),
    lname: yup
        .string()
        .required('This field is required.')
        .matches(
            /^[a-zA-Z0-9\s\'-]+$/,
            'Please enter a valid name.',
        ),
    email: yup.string()
        .email('Invalid email format.')
        .required('This field is required.')
        .dupeEmail('Email has already been registered.'),
    email_confirm: yup.string()
        .oneOf([yup.ref('email'), null], 'This value should be the same')
        .required('This field is required'),
    phone: yup
        .string()
        .required('This field is required.')
        .dupePhone('Phone has already been registered.', false, regTypeId),
    address: yup.string().required('This field is required.'),
    city: yup
        .string()
        .required('This field is required'),
    state_id: yup.string().required('This field is required.'),
    zipcode: yup.string().required('This field is required.').matches(/^(\d{5}|\w{6}|\w\d\w\s?\d\w\d)$/, ' '),
    country_id: yup.string().required('This field is required.'),
    timezone_id: yup.string().required('This field is required.'),
    birthdate: regTypeId === FACILITY_MANAGER.id ? yup.string().nullable() : yup
        .string()
        .required('This field is required.')
        .validDate()
        .test(
            'dob',
            'You must be older than 18 years old.',
            (value: string) => {
                return moment().diff(moment(value),'years') >= 18;
            },
        ),
    password: yup.string()
        .required('This field is required.')
        .strongPassword(' '),
    password_confirm: yup.string().required('This field is required.').passwordConfirmation(' '),
    question: yup.string().required('This field is required.'),
    answer: yup.string().required('This field is required.'),
    terms: yup.bool().oneOf([true], 'You need to accept the terms and conditions'),
    privacy: yup.bool().oneOf([true], 'You need to accept the privacy'),
    agree: yup.bool().oneOf([true], 'You need to accept the terms and conditions'),
}));


export const initialValues: FormValues = {
    fname: '',
    lname: '',
    email: '',
    email_confirm: '',
    phone: '',
    birthdate: '',
    password: '',
    password_confirm: '',
    question: '',
    answer: '',
    terms: false,
    privacy: false,
    agree: false,
    opt_in_email: true,
    opt_in_text: false,
    state_id: '',
    zipcode: '',
    city: '',
    timezone_id: '',
};